import React, { Component, Fragment } from "react";
import { withRouter, Route, Link } from "react-router-dom";
import { connect } from "react-redux";
import Registration from "./Registration";
import * as c from "../constant";

class JobSeeker extends Component {
  state = {
    jobseeker: false,
  };

  registration = (e) => {
    this.setState({
      jobseeker: !this.state.jobseeker,
    });
  };

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch({
      type: c.GET_COUNTRY,
    });
    dispatch({
      type: c.GET_CATEGORY,
    });
    dispatch({
      type: c.GET_CLIENT,
    });
    dispatch({
      type: c.GET_LOCATION,
    });
  }

  handleChange = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { name, value } = e.target;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [name]: value || "",
      },
    });
  };

  handleChangeSelect = (key) => (value) => {
    const { dispatch } = this.props;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [key]: value || "",
      },
    });
  };

  search = (e) => {
    e.preventDefault();
    const { dispatch, form_data } = this.props;
    dispatch({
      type: c.GET_JOBS,
      args: form_data.toJS(),
    });
  };

  render() {
    const { match, isAuthenticated } = this.props;
    return (
      <Fragment>
        <div className="page-title-banner _jobseeker2">
          <div className="title">
            <h1>Job Seekers</h1>
          </div>
        </div>
        <div className=" container-fluid jobseekers-tabs-btn-grp">
          <div className="inside-page-section container">
            <div
              id="jobseeker-btn-group"
              className="btn-group btn-group-lg btn-block"
              role="group"
              aria-label="Basic example"
            >
              <Link
                to={`/jobseeker`}
                className="btn btn-primary btn-block mb-0 mt-0 text-center"
              >
                <i className="fas fa-search"></i>{" "}
                <span className="btn-text">SEARCH JOBS</span>
              </Link>
              <Link
                to={`/register`}
                className="btn btn-primary btn-block mb-0 mt-0 text-center"
              >
                <i className="fas fa-user-plus"></i>{" "}
                <span className="btn-text">SIGN UP</span>
              </Link>
              {isAuthenticated ? null : (
                <Link
                  to={`/jobseekerslogin`}
                  className="btn btn-primary btn-block mb-0 mt-0 text-center"
                >
                  <i className="fas fa-sign-in"></i>{" "}
                  <span className="btn-text">JOB SEEKERS LOGIN</span>
                </Link>
              )}
            </div>
          </div>
        </div>
        {this.state.jobseeker && <Registration />}
        <Route path={`${match.path}`} component={Registration} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, routeParams) => {
  const { loadingTypes } = state.loading;
  const form_data = state.auth.get("form_data");
  const countries = state.auth.get("countries");
  const categories = state.auth.get("categories");
  const clients = state.auth.get("clients");
  const jobs = state.auth.get("jobs");
  const isAuthenticated = state.auth.get("isAuthenticated");
  const profile = state.auth.get("profile");

  return {
    isLoading: loadingTypes.length > 0,
    form_data,
    countries,
    categories,
    clients,
    jobs,
    isAuthenticated,
    profile,
  };
};

export default withRouter(connect(mapStateToProps)(JobSeeker));
